import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

const EXCLUDED_PATHS = ['/login', '/signup', '/register', '/checkout', '/verify-email', '/log-in', '/sign-up']
const PROMPT_DELAY_MS = 3000

const GoogleOneTap = () => {
  const user = useSelector(({ ui }) => ui.user)
  const fetchingUser = useSelector(({ ui }) => ui.fetchingUser)
  const location = useLocation()
  const initialized = useRef(false)

  const hasSessionCookie = typeof document !== 'undefined' && document.cookie.includes('userSession')

  const shouldShow =
    !fetchingUser &&
    !user?.email &&
    !hasSessionCookie &&
    !EXCLUDED_PATHS.some(path => location.pathname.startsWith(path)) &&
    typeof window !== 'undefined'

  // Cancel the prompt whenever the user becomes authenticated
  useEffect(() => {
    if (!shouldShow && window.google?.accounts?.id) {
      window.google.accounts.id.cancel()
      initialized.current = false
    }
  }, [shouldShow])

  useEffect(() => {
    if (!shouldShow) return

    const handleCredentialResponse = response => {
      // Submit via hidden form so Passport can handle the redirect flow
      const form = document.createElement('form')
      form.method = 'POST'
      form.action = '/api/auth/google-one-tap/callback'
      form.style.display = 'none'

      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = 'credential'
      input.value = response.credential
      form.appendChild(input)

      const returnTo = document.createElement('input')
      returnTo.type = 'hidden'
      returnTo.name = 'returnTo'
      returnTo.value = window.location.pathname + window.location.search
      form.appendChild(returnTo)

      document.body.appendChild(form)
      form.submit()
    }

    const initOneTap = () => {
      if (initialized.current) return
      initialized.current = true

      window.google.accounts.id.initialize({
        client_id: CONFIG.oAuth.google.clientKey,
        callback: handleCredentialResponse,
        auto_select: false,
        cancel_on_tap_outside: false,
        use_fedcm_for_prompt: true
      })

      setTimeout(() => {
        window.google.accounts.id.prompt(notification => {
          if (notification.isNotDisplayed()) {
            console.log('Google One Tap not displayed:', notification.getNotDisplayedReason())
          }
          if (notification.isSkippedMoment()) {
            console.log('Google One Tap skipped:', notification.getSkippedReason())
          }
          if (notification.isDismissedMoment()) {
            console.log('Google One Tap dismissed:', notification.getDismissedReason())
          }
        })
      }, PROMPT_DELAY_MS)
    }

    // Load the Google Identity Services script
    if (window.google?.accounts?.id) {
      initOneTap()
    } else {
      if (!document.querySelector('script[src="https://accounts.google.com/gsi/client"]')) {
        const script = document.createElement('script')
        script.src = 'https://accounts.google.com/gsi/client'
        script.async = true
        script.defer = true
        script.onload = initOneTap
        document.head.appendChild(script)
      }
    }

    return () => {
      if (window.google?.accounts?.id) {
        window.google.accounts.id.cancel()
      }
    }
  }, [shouldShow])

  return null
}

export default GoogleOneTap
